export const normalizeFolderKey = (label) => {
  if (typeof label !== "string") return "";
  return label.trim().toLowerCase();
};

export const getFolderDisplayLabel = (label, t) => {
  if (typeof label !== "string" || label.trim() === "") {
    return "General";
  }
  return label.trim();
};

export const sortBlocksByInitialDateDesc = (blocks) => {
  if (!Array.isArray(blocks)) return [];

  return [...blocks].sort((a, b) => {
    const dateA =
      a.initialDate instanceof Date
        ? a.initialDate.getTime()
        : new Date(a.initialDate).getTime();
    const dateB =
      b.initialDate instanceof Date
        ? b.initialDate.getTime()
        : new Date(b.initialDate).getTime();

    const validA = Number.isFinite(dateA);
    const validB = Number.isFinite(dateB);

    if (validA && validB) return dateB - dateA;
    if (validA) return -1;
    if (validB) return 1;
    return 0;
  });
};

export const buildSummaryBlocks = (blocks) => {
  const summaryCandidates = Array.isArray(blocks)
    ? blocks.filter((block) => (block?.protocolsAndExercises?.length ?? 0) > 0)
    : [];
  return sortBlocksByInitialDateDesc(summaryCandidates);
};

export const buildFolderSections = (blocks, { searchTerm, t }) => {
  if (!Array.isArray(blocks)) return [];

  const foldersMap = Object.create(null);

  blocks.forEach((block) => {
    const folderKey = normalizeFolderKey(block.label);
    const hasFolderSection = Object.prototype.hasOwnProperty.call(
      foldersMap,
      folderKey,
    );
    if (!hasFolderSection) {
      foldersMap[folderKey] = {
        folderKey,
        folderLabel: getFolderDisplayLabel(block.label, t),
        blocks: [],
      };
    }
    foldersMap[folderKey].blocks.push(block);
  });

  let sections = Object.values(foldersMap).map((section) => {
    const sortedBlocks = sortBlocksByInitialDateDesc(section.blocks);
    const latestBlock = sortedBlocks[0];
    const latestInitialDateTs =
      latestBlock && latestBlock.initialDate
        ? latestBlock.initialDate instanceof Date
          ? latestBlock.initialDate.getTime()
          : new Date(latestBlock.initialDate).getTime()
        : 0;

    return {
      ...section,
      blocks: sortedBlocks,
      latestInitialDateTs: Number.isFinite(latestInitialDateTs)
        ? latestInitialDateTs
        : 0,
    };
  });

  if (searchTerm && searchTerm.trim() !== "") {
    const term = searchTerm.trim().toLowerCase();
    sections = sections
      .map((section) => {
        const isFolderMatch = section.folderLabel.toLowerCase().includes(term);
        if (isFolderMatch) {
          return section;
        }
        return {
          ...section,
          blocks: section.blocks.filter(
            (b) => b.name && b.name.toLowerCase().includes(term)
          ),
        };
      })
      .filter((section) => section.blocks.length > 0);
  }

  sections.sort((a, b) => {
    if (a.latestInitialDateTs !== b.latestInitialDateTs) {
      return b.latestInitialDateTs - a.latestInitialDateTs;
    }
    return a.folderLabel.localeCompare(b.folderLabel);
  });

  return sections;
};
